export default __webpack_public_path__ + "static/media/E-WEB-Goal-03.f6b9f937.png";